exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toastPaymentComponent-frameContainer {\n  display: flex;\n  height: 600px; }\n", ""]);

// exports
